import React from 'react';
import intl from 'react-intl-universal';
import './NewDialog.scss';
import { createPortal } from 'react-dom';

export interface INewDialog {
  onOk?: () => any;
  onCancel?: () => void;
  className?: string;
  wrapClassName?: string;
  onMask?: () => any;
  showCancel: boolean;
  okText?: string;
  cancelText?: string;
}

export default class NewDialog extends React.Component<INewDialog, any> {
  containerEl = document.createElement('div');
  realOnOk = () => {
    if (typeof this.props.onOk === 'function') {
      const result = this.props.onOk();
      //只要不是返回的false，都关闭弹框
      if (false !== result) {
        this.props.onCancel && this.props.onCancel();
      }
    } else {
      this.props.onCancel && this.props.onCancel();
    }
  };
  componentDidMount(): void {
    document.body.appendChild(this.containerEl);
  }
  componentWillUnmount(): void {
    document.body.removeChild(this.containerEl);
  }

  render() {
    const {
      onCancel,
      className,
      onMask,
      showCancel = true,
      okText,
      cancelText,
      wrapClassName
    } = this.props;
    return createPortal(
      <div
        className={
          'new-dialog-mask ' + (className || '') + ` ${wrapClassName || ''}`
        }
        onClick={onMask}
      >
        <div
          className="new-dialog-main"
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <div className="content">{this.props.children}</div>

          <footer className="new-dialog-footer">
            {showCancel && (
              <button className="footer-button button1" onClick={onCancel}>
                {cancelText || intl.get('cancel')}
              </button>
            )}
            <button className="footer-button button2" onClick={this.realOnOk}>
              {okText || intl.get('ok')}
            </button>
          </footer>
        </div>
      </div>,
      this.containerEl
    );
  }
}
